import React from 'react'
import AddBundleOfferForm from '../../modules/BundleOffer/components/AddBundleOfferForm'
export default function AddBundleOfferPage() {
  return <AddBundleOfferForm />
}
